/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */

import './app/core/models/WindowExtensions';

window.__Zone_disable_customElements = true;
